// import { useState } from "react"
// import styled, { ThemeProvider, keyframes } from "styled-components"
// import { lightTheme } from "./Themes"
// import { Develope } from "./AllSvgs"
// import { motion } from "framer-motion"


// import LogoComponent from "../subComponents/LogoComponent"
// import SocialIcons from "../subComponents/SocialIcons"
// import PowerButton from "../subComponents/PowerButton"
// import ParticleComponent from "../subComponents/ParticleComponent"
// import BigTitle from "../subComponents/BigTitle"

// const Box = styled.div`
//   background-color: ${(props) => props.theme.body};
//   width: 100vw;
//   height: 100vh;
//   position: relative;
//   display: flex;
//   justify-content: space-evenly;
//   align-items: center;

//   @media (max-width: 768px) {
//     flex-direction: column;
//     justify-content: flex-start;
//     padding-top: 5rem;
//   }
// `

// const Content = styled.div`
//   flex: 1;
//   overflow-y: auto;
//   margin-top: 4rem;
//   padding-right: 1rem;

//   --scrollbar-thumb-color: ${(props) => props.theme.text};

//   &::-webkit-scrollbar {
//     width: 6px;
//   }

//   &::-webkit-scrollbar-thumb {
//     background: var(--scrollbar-thumb-color);
//     border-radius: 6px;
//     transition: background 0.3s ease-in-out;
//   }

//   &::-webkit-scrollbar-track {
//     background: transparent;
//   }
// `

// const Main = styled.div`
//   border: 2px solid ${(props) => props.theme.text};
//   color: ${(props) => props.theme.text};
//   background-color: ${(props) => props.theme.body};
//   padding: 2rem;
//   width: 30vw;
//   height: 60vh;
//   z-index: 3;
//   line-height: 1.5;
//   cursor: pointer;
//   font-family: 'Ubuntu Mono', monospace;
//   display: flex;
//   flex-direction: column;
//   position: relative;

//   @media (max-width: 768px) {
//   display: ${(props) => (props.isVisible ? 'flex' : 'none')};
//   width: 90vw;
//   height: auto;
//   margin-bottom: 2rem;
// }


//   &:hover {
//     color: ${(props) => props.theme.body};
//     background-color: ${(props) => props.theme.text};

//     & ${Content} {
//       --scrollbar-thumb-color: white;
//     }
//   }
// `

// // Bounce animation for the title itself
// const bounce = keyframes`
//   0%, 100% { transform: translateY(0); }
//   50% { transform: translateY(-3px); }
// `;

// const Title = styled.h2`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: calc(1em + 1vw);
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   padding: 1rem;
//   background-color: ${(props) => props.theme.body};
//   border-bottom: 2px solid ${(props) => props.theme.text};
//   z-index: 10;

//   ${Main}:hover & {
//     background-color: ${(props) => props.theme.text};
//     border-bottom: 2px solid ${(props) => props.theme.body};
//     & > * {
//       fill: ${(props) => props.theme.body};
//     }
//   }

//   & > *:first-child {
//     margin-right: 1rem;
//   }

//   @media (max-width: 768px) {
//   cursor: pointer;
//   border-radius: 8px;
//   border: 1px solid ${(props) => props.theme.text};
//   margin-bottom: 1rem;
//   background-color: ${(props) => props.theme.body};
//   animation: ${bounce} 2s infinite ease-in-out;
//   transition: background-color 0.3s ease;
// }

// `

// const Description = styled.div`
//   color: ${(props) => props.theme.text};
//   font-size: calc(0.6em + 1vw);
//   padding: 0.5rem 0;

//   ${Main}:hover & {
//     color: ${(props) => props.theme.body};
//   }

//   strong {
//     margin-bottom: 1rem;
//     text-transform: uppercase;
//   }

//   @media (max-width: 768px) {
//     font-size: calc(0.5em + 1vw);
//   }
// `

// // const ToggleButton = styled.button`
// //   position: absolute;
// //   bottom: 1rem;
// //   right: 1rem;
// //   background: none;
// //   border: none;
// //   color: ${(props) => props.theme.text};
// //   cursor: pointer;
// //   font-size: 1.5rem;
// //   display: none;

// //   @media (max-width: 768px) {
// //     display: block;
// //   }

// //   ${Main}:hover & {
// //     color: ${(props) => props.theme.body};
// //   }
// // `

// const Highlight = styled.span`
//   background: rgba(0, 123, 255, 0.2); /* Light blue highlight */
//   padding: 3px 6px;
//   border-radius: 4px;
//   color: #0056b3; /* Deep blue text */
//   font-weight: 600;
// `;

// // Pulse animation for the "Click" text
// const pulse = keyframes`
//   0% { opacity: 0.6; transform: scale(1); }
//   50% { opacity: 1; transform: scale(1.05); }
//   100% { opacity: 0.6; transform: scale(1); }
// `;

// export const ClickHint = styled.div`
//   text-align: center;
//   font-size: 0.875rem;
//   color: ${(props) => props.theme.text};
//   animation: ${pulse} 2s infinite;
//   margin-top: 0.2rem;
//   margin-bottom: 0.5rem;
//   user-select: none;
//   z-index:1000;

//     ${Main}:hover & {
//     color: ${(props) => props.theme.body};
//   }

//   @media (min-width: 769px) {
//     display: none; /* Optional: hide on large screens */
//   }
// `;

// const TitleContainer = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const ScrollContainer = styled.div`
//   display: flex;
//   gap: 2rem;
//   overflow-x: auto;
//   width: 100%;
//   padding: 2rem;

//   &::-webkit-scrollbar {
//     height: 6px;
//   }
// `;

// const pageVariants = {
//   initial: { opacity: 0, y: -50 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   exit: { opacity: 0, y: 50, transition: { duration: 0.5 } },
// }

// const MySkillsPage = () => {
//   // const [frontEndVisible, setFrontEndVisible] = useState(true)
//   // const [backEndVisible, setBackEndVisible] = useState(false)
//   const [activeTab, setActiveTab] = useState("frontend")


//   // const toggleFrontEnd = () => setFrontEndVisible(!frontEndVisible)
//   // const toggleBackEnd = () => setBackEndVisible(!backEndVisible)

//   return (
//     <ThemeProvider theme={lightTheme}>
//       <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants}>
//         <Box>
//           <ScrollContainer>
//           <LogoComponent theme="light" />
//           <SocialIcons theme="light" />
//           <PowerButton />
//           <ParticleComponent theme="light" />


//           <Main isVisible={activeTab === "frontend"}>

//             {/* <Title onClick={() => setActiveTab("backend")}>
//               <Develope width={40} height={40} /> Front-End Developer
//             </Title> */}


//             <TitleContainer>
//               <ClickHint> Tap to switch view</ClickHint>
//               <Title onClick={() => setActiveTab("backend")}>
//                 <Develope width={40} height={40} /> Front-End Developer
//               </Title>
//             </TitleContainer>

//             <Content>
//               <Description>
//                 I design and build <Highlight>responsive, high-performance interfaces</Highlight> that feel intuitive and alive. My focus is simple: <Highlight>clarity, speed, and user flow</Highlight>.
//               </Description>

//               <Description>
//                 <strong> Approach to Frontend </strong>
//                 <ul>
//                   <li>Building modern applications with <Highlight>React.js</Highlight>, <Highlight>TypeScript</Highlight>, and <Highlight>Next.js</Highlight></li>
//                   <li>Crafting fluid interactions using <Highlight>Framer Motion</Highlight> and animation-driven UI patterns</li>
//                   <li>Designing systems that prioritize <Highlight>performance, accessibility, and scalability</Highlight></li>
//                   <li>Experience with desktop stacks like <Highlight>WinForms</Highlight> and <Highlight>.NET MAUI</Highlight> (now secondary focus)</li>
//                 </ul>
//               </Description>

//               <Description>
//                 <strong> Tools & Workflow </strong>
//                 <p>VS Code, Git, GitHub, Figma (for collaboration), Chrome DevTools, Framer Motion, modern component-driven architectures</p>
//               </Description>
//             </Content>
//             {/* <Content>
//     <Description>
//       I specialize in crafting <Highlight>responsive, dynamic, and visually engaging</Highlight> user interfaces that prioritize <Highlight>usability and performance</Highlight>.
//     </Description>
//     <Description>
//       <strong> Passion for UI/UX Development </strong>
//       <ul>
//         <li>Modern web applications using <Highlight>React.js</Highlight> and <Highlight>Framer Motion</Highlight></li>
//         <li>Desktop applications built with <Highlight>WinForms</Highlight> and <Highlight>MAUI</Highlight></li>
//         <li>Creating seamless, interactive experiences with <Highlight>animation frameworks</Highlight></li>
//       </ul>
//     </Description>
//     <Description>
//       <strong> Development Tools </strong>
//       <p>Visual Studio Code, Visual Studio 2022, GitHub, Framer Motion, etc.</p>
//     </Description>
//   </Content> */}
//             {/* <ToggleButton onClick={toggleFrontEnd}>{frontEndVisible ? <ChevronUp /> : <ChevronDown />}</ToggleButton> */}
//           </Main>

//           <Main isVisible={activeTab === "backend"}>

//             <TitleContainer>
//               <ClickHint> Tap to switch view</ClickHint>
//               <Title onClick={() => setActiveTab("ai-embedded")}>
//                 <Develope width={40} height={40} /> Back-End Developer
//               </Title>
//             </TitleContainer>
//             {/* <Title onClick={() => setActiveTab("frontend")}>
//               <Backend width={40} height={40} /> Back-End Developer
//             </Title> */}
//             <Content>
//               <Description>
//                 I build <Highlight>robust backend systems</Highlight> that are designed to scale, secure data, and handle real-world complexity without breaking.
//               </Description>

//               <Description>
//                 <strong> Core Expertise </strong>
//                 <ul>
//                   <li>Developing APIs with <Highlight>Node.js (Express)</Highlight>, <Highlight>TypeScript</Highlight>, and <Highlight>Python (Flask, FastAPI)</Highlight></li>
//                   <li>Designing <Highlight>RESTful</Highlight> and <Highlight>GraphQL</Highlight> services for flexible data access</li>
//                   <li>Building  <Highlight>Telegram bots </Highlight> and <Highlight>Whatapp bots</Highlight> services for flexible autonomous customer support and ecommerce agent</li>
//                   <li>Working with databases: <Highlight>MySQL</Highlight>, <Highlight>PostgreSQL</Highlight>, <Highlight>MongoDB</Highlight>, and <Highlight>SQLite</Highlight></li>
//                   <li>Using ORMs and validation tools to enforce <Highlight>data integrity and clean architecture</Highlight></li>
//                   <li>Implementing authentication, authorization, and secure system design patterns</li>
//                 </ul>
//               </Description>

//               <Description>
//                 <strong> Tools & Workflow </strong>
//                 <p>VS Code, Postman, Docker, GitHub, Prisma, Sequelize, Mongoose, Zod, JWT, REST/GraphQL tooling, ClaudeCode</p>
//               </Description>
//             </Content>
//             {/* <Content>
//     <Description>
//       I architect and develop <Highlight>scalable, secure, and high-performance backend systems</Highlight> that power applications efficiently.
//     </Description>
//     <Description>
//       <strong> Core Expertise </strong>
//       <ul>
//         <li>Building RESTful APIs and backend services with <Highlight>C# (.NET)</Highlight> and <Highlight>Python (Flask, FastAPI)</Highlight></li>
//         <li>Database management with <Highlight>MySQL</Highlight> and <Highlight>SQLite</Highlight>, ensuring optimized data storage and retrieval</li>
//         <li>Authentication, authorization, and security best practices for <Highlight>scalable web and desktop applications</Highlight></li>
//       </ul>
//     </Description>
//     <Description>
//       <strong> Development Tools </strong>
//       <p>Visual Studio 2022, PyCharm, MySQL Workbench, GitHub, Postman, etc.</p>
//     </Description>
//   </Content> */}
//             {/* <ToggleButton onClick={toggleBackEnd}>{backEndVisible ? <ChevronUp /> : <ChevronDown />}</ToggleButton> */}
//           </Main>

//           <Main isVisible={activeTab === "ai-embedded"}>

//             <TitleContainer>
//               <ClickHint> Tap to switch view</ClickHint>
//               <Title onClick={() => setActiveTab("DEVOPS")}>
//                   <Develope width={40} height={40} /> AI + EMBEDDED SYSTEMS
//               </Title>
//             </TitleContainer>
// <Content>
//   <Description>
//     I explore the intersection of <Highlight>software, hardware, and intelligence</Highlight>—building systems that don’t just run, but <Highlight>respond to the real world</Highlight>.
//   </Description>

//   <Description>
//     <strong> Embedded & AI Work </strong>
//     <ul>
//       <li>Working with <Highlight>Raspberry Pi</Highlight> and <Highlight>Arduino</Highlight> for real-world system interaction</li>
//       <li>Building lightweight <Highlight>face recognition systems</Highlight> using Python on embedded devices</li>
//       <li>Programming microcontrollers in <Highlight>C</Highlight> for input-response systems and automation</li>
//       <li>Integrating sensors and components for <Highlight>practical electrical experiments</Highlight></li>
//     </ul>
//   </Description>

//   <Description>
//     <strong> Tools & Environment </strong>
//     <p>Arduino IDE, VS Code, Python (OpenCV, basic ML libraries), C/C++, Linux environments, GPIO interfacing, hardware-software integration workflows</p>
//   </Description>
// </Content>
//           </Main>

//             <Main isVisible={activeTab === "DEVOPS"}>

//             <TitleContainer>
//               <ClickHint> Tap to switch view</ClickHint>
//               <Title onClick={() => setActiveTab("frontend")}>
//                   <Develope width={40} height={40} /> DEVOPS
//               </Title>

//             </TitleContainer>
//             <Content>
//               <Description>
//                 I handle deployment like a final boss level—taking systems from local builds to <Highlight>secure, production-ready infrastructure</Highlight>.
//               </Description>

//               <Description>
//                 <strong> DevOps Experience </strong>
//                 <ul>
//                   <li>Deploying applications on <Highlight>AWS</Highlight>, <Highlight>Google Cloud</Highlight>, <Highlight>Render</Highlight>, <Highlight>Railway</Highlight>, and <Highlight>Hostinger</Highlight></li>
//                   <li>Managing servers via <Highlight>Linux CLI</Highlight> and cPanel environments</li>
//                   <li>Setting up <Highlight>secure HTTPS systems</Highlight>, domains, and production pipelines</li>
//                   <li>Working with <Highlight>Docker</Highlight> for containerized deployments</li>
//                   <li>Configuring databases, storage systems, and email services for live applications</li>
//                 </ul>
//               </Description>

//               <Description>
//                 <strong> Tools & Workflow </strong>
//                 <p>Docker, GitHub Actions (CI/CD), Linux (Bash scripting), Nginx, PM2, cloud dashboards, terminal-based deployment workflows</p>
//               </Description>
//             </Content>


//             </Main>

//           <BigTitle text="SKILLS" top="80%" left="30%" />
//           </ScrollContainer>
//         </Box>
//       </motion.div>
//     </ThemeProvider>
//   )
// }

// export default MySkillsPage


import React from 'react'
import styled, { ThemeProvider, keyframes } from 'styled-components'
import { motion } from 'framer-motion'
import { useSearchParams } from 'react-router-dom'
import { lightTheme } from './Themes'
import { Develope } from './AllSvgs'

import LogoComponent from '../subComponents/LogoComponent'
import SocialIcons from '../subComponents/SocialIcons'
import PowerButton from '../subComponents/PowerButton'
import ParticleComponent from '../subComponents/ParticleComponent'
import BigTitle from '../subComponents/BigTitle'

import { Skills } from '../data/SkillsData'

/* ---------- layout ---------- */

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  min-height: 100vh;
  position: relative;
  padding: 7rem 2rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 6rem 1rem 3rem;
  }
`

const Shell = styled.div`
  width: min(1000px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  position: relative;
  z-index: 3;
`

const spin = keyframes`
  to { transform: rotate(360deg); }
`

const Orbit = styled.div`
  position: fixed;
  right: -8rem;
  bottom: -8rem;
  width: 24rem;
  height: 24rem;
  border: 1px dashed ${(props) => props.theme.text};
  border-radius: 50%;
  opacity: 0.25;
  pointer-events: none;
  animation: ${spin} 40s linear infinite;

  &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${(props) => props.theme.text};
  }
`

/* ---------- tabs ---------- */

const TabBar = styled.div`
  display: flex;
  gap: 0.4rem;
  padding: 0.3rem;
  border: 1px solid ${(props) => props.theme.text};
  border-radius: 999px;
  background: ${(props) => props.theme.body};
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const Tab = styled.button`
  position: relative;
  flex-shrink: 0;
  padding: 0.55rem 1.3rem;
  background: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-family: 'Ubuntu Mono', monospace;
  font-size: 0.95rem;
  color: ${(props) => (props.$active ? props.theme.body : props.theme.text)};
  transition: color 0.3s ease;

  span {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 600px) {
    padding: 0.45rem 0.9rem;
    font-size: 0.85rem;
  }
`

const Pill = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: ${(props) => props.theme.text};
  border-radius: 999px;
`

/* ---------- panel ---------- */

const Panel = styled(motion.div)`
  width: 100%;
  padding: 2.5rem;
  border: 2px solid ${(props) => props.theme.text};
  border-radius: 0 50px 0 50px;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  font-family: 'Ubuntu Mono', monospace;

  @media (max-width: 768px) {
    padding: 1.5rem 1.2rem;
    border-radius: 0 30px 0 30px;
  }
`

const Module = styled.div`
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  opacity: 0.6;
  margin-bottom: 0.8rem;
`

const Heading = styled.h2`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: calc(1.2em + 1vw);
  margin-bottom: 0.4rem;
`

const Tagline = styled.p`
  font-size: calc(0.8em + 0.3vw);
  opacity: 0.7;
  margin-bottom: 1rem;
`

const Summary = styled.p`
  font-family: 'Karla', sans-serif;
  font-size: calc(0.85em + 0.3vw);
  line-height: 1.6;
  max-width: 70ch;
  margin-bottom: 2rem;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.2rem;
`

const GroupCard = styled(motion.div)`
  padding: 1.2rem;
  border: 1px solid ${(props) => props.theme.text};
  border-radius: 0 24px 0 24px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  }
`

const GroupTitle = styled.h3`
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin-bottom: 0.9rem;

  &::before {
    content: '✦ ';
  }
`

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

const Chip = styled.span`
  padding: 0.3rem 0.8rem;
  border: 1px ${(props) => (props.$dashed ? 'dashed' : 'solid')} ${(props) => props.theme.text};
  border-radius: 999px;
  font-size: 0.85rem;
  cursor: default;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.text};
    color: ${(props) => props.theme.body};
    transform: scale(1.06);
  }
`

const ToolsRow = styled(motion.div)`
  margin-top: 1.8rem;
  padding-top: 1.2rem;
  border-top: 1px dashed ${(props) => props.theme.text};
`

/* ---------- animation ---------- */

const pageVariants = {
  initial: { opacity: 0, y: -50 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, y: 50, transition: { duration: 0.5 } },
}

const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, staggerChildren: 0.1 } },
}

const blockVariants = {
  hidden: { opacity: 0, y: 15 },
  show: { opacity: 1, y: 0 },
}

/* ---------- page ---------- */

const MySkillsPage = () => {
  const [params, setParams] = useSearchParams()

  const requested = params.get('tab')
  const active = Skills.find((s) => s.key === requested) || Skills[0]
  const index = Skills.indexOf(active) + 1

  const selectTab = (key) => setParams({ tab: key }, { replace: true })

  return (
    <ThemeProvider theme={lightTheme}>
      <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants}>
        <Box>
          <LogoComponent theme="light" />
          <SocialIcons theme="light" />
          <PowerButton />
          <ParticleComponent theme="light" />
          <Orbit />

          <Shell>
            <TabBar>
              {Skills.map((s) => (
                <Tab key={s.key} $active={active.key === s.key} onClick={() => selectTab(s.key)}>
                  {active.key === s.key && <Pill layoutId="skill-pill" />}
                  <span>{s.label}</span>
                </Tab>
              ))}
            </TabBar>

            <Panel key={active.key} variants={panelVariants} initial="hidden" animate="show">
              <motion.div variants={blockVariants}>
                <Module>
                  Module {String(index).padStart(2, '0')} / {String(Skills.length).padStart(2, '0')}
                </Module>
                <Heading>
                  <Develope width={40} height={40} /> {active.title}
                </Heading>
                <Tagline>{active.tagline}</Tagline>
                <Summary>{active.summary}</Summary>
              </motion.div>

              <Grid>
                {active.groups.map((g) => (
                  <GroupCard key={g.title} variants={blockVariants}>
                    <GroupTitle>{g.title}</GroupTitle>
                    <Chips>
                      {g.items.map((item) => (
                        <Chip key={item}>{item}</Chip>
                      ))}
                    </Chips>
                  </GroupCard>
                ))}
              </Grid>

              {active.tools?.length > 0 && (
                <ToolsRow variants={blockVariants}>
                  <GroupTitle>Toolkit</GroupTitle>
                  <Chips>
                    {active.tools.map((t) => (
                      <Chip key={t} $dashed>{t}</Chip>
                    ))}
                  </Chips>
                </ToolsRow>
              )}
            </Panel>
          </Shell>

          <BigTitle text="SKILLS" top="10%" right="5%" />
        </Box>
      </motion.div>
    </ThemeProvider>
  )
}

export default MySkillsPage